import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";

// project imports
import { useAuth } from "../../../utils/auth";
import { useEffect } from "react";

// ==============================|| AUTH GUARD ||============================== //

/**
 * Authentication guard for routes
 * @param {PropTypes.node} children children element/node
 */
const ProjektyXXLGuard = ({ children }) => {
  const { user } = useAuth();
  const haveProjektyXXLRole = user
    ? JSON.stringify(user.roles).includes("projektyXXL")
    : false;
  const isAdmin = user ? JSON.stringify(user.roles).includes("admin") : false;
  const navigate = useNavigate();

  useEffect(() => {
    if (!user) {
      navigate("/login");
    }
    if (user && !haveProjektyXXLRole && !isAdmin) {
      navigate("/app/not-allowed");
    }
  }, [user, navigate]);

  return children;
};

ProjektyXXLGuard.propTypes = {
  children: PropTypes.node,
};

export default ProjektyXXLGuard;
